import OnboardingGeneralData from "./OnboardingGeneralData";

export default OnboardingGeneralData;
